import { connect } from 'react-redux';
import { IUser } from '../../models';
import { IRootState } from '../../redux/state';
import OrderCalendar from './OrderCalendar';
import { bindActionCreators, Dispatch } from 'redux';
import * as orderActions from '../../redux/modules/order/orderActions';
import { orderConstants } from '../../redux/modules/order/orderConstants';
import { createLoadingSelector } from '../../redux/modules/loading/loadingSelectors';

const isOrdersLoading = createLoadingSelector(
  orderConstants.GET_ORDER_OVERVIEW
);

function mapStateToProps(state: IRootState) {
  return {
    authentication: state.authentication as unknown as IUser,
    orderOverview: state.order.orderOverview,
    calendarMonth: state.order.calendarMonth,
    isLoading: isOrdersLoading(state),
    isCalendarVisible: state.order.isCalendarVisible,
    orderOverviewFilter: state.order.orderCalendarFilter,
    calendarView: state.order.calendarView,
    allFractions: state.order.allFractions,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    orderActions: bindActionCreators(orderActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderCalendar);
